<template>
    <b-row>
        <b-col
            cols="12"
            xl="4"
            lg="5"
            md="5"
        >
            <user-info-card/>
        </b-col>
        <b-col
            cols="12"
            xl="8"
            lg="7"
            md="7"
        >
            <b-row class="match-height">
                <user-plan-view/>
                <reset-and-deactivate/>
            </b-row>
            <b-row class="match-height">
                <b-col v-if="userStore.profile.is_stripe_customer" cols="12" xl="6" lg="6" md="6">
                    <div style="height: 300px;overflow-y: scroll;" class="card">
                        <div class="card-header">
                            <h4 class="card-title">Payments</h4>
                            <button type="button" data-toggle="modal" data-target="#add-card-modal" class="btn btn-sm btn-outline-primary d-flex align-items-center">
                                <vue-feather class="mr-50" size="14" type="plus" ></vue-feather>
                                <span>Add Card</span>
                            </button>
                        </div>
                        <div class="card-body">
                            <div
                                class="card card-payment shadow-none bg-transparent border-secondary"
                                v-for="paymentMethod in userStore.profile.payment_methods"
                            >
                                <div class="card-body">
                                    <div class="d-flex flex-sm-row flex-column pa-4">
                                        <div class="text-no-wrap">
                                            <img :src="billingStore.cards[paymentMethod.card.brand]">
                                            <p class="my-50">
                                                {{ paymentMethod.name }}
                                                <span
                                                    v-if="userStore.profile.default_payment_method == paymentMethod.id"
                                                    class="badge badge-secondary"
                                                >Default</span>
                                            </p>
                                            <span>**** **** **** {{ paymentMethod.card.last4 }}</span>
                                        </div>
                                        <div class="flex-grow-1"></div>
                                        <div class="d-flex flex-column text-sm-end gap-2">
                                            <div v-if="userStore.profile.default_payment_method != paymentMethod.id" class="order-sm-0 order-1">
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-primary mr-50"
                                                    @click="billingStore.defaultCard(paymentMethod.id)"
                                                >
                                                    Make Default
                                                </button>
                                                <button @click="billingStore.deleteCard(paymentMethod.id)" type="button" class="btn btn-sm btn-primary">
                                                    Delete
                                                </button>
                                            </div>
                                            <span class="mt-auto order-sm-1 order-0">
                                                Card expires at {{ paymentMethod.card.exp_month }}/{{ paymentMethod.card.exp_year }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <payment-modal
                        :id="'add-card-modal'"
                    >
                        <template #header>
                            <div class="d-flex">
                                <img :src="settingStore.modalLogo" class="mb-2 w-50 mx-auto" alt="creditfixrr">
                            </div>
                            <h3 class="text-primary text-center mb-1">
                                {{ localizationStore.translate("add.card.modal.title") }}
                            </h3>
                        </template>
                        <template #footer="{ addCard }">
                            <div class="row gy-1 gx-2 mt-75">
                                <div class="col-12 text-center">
                                    <button type="button" @click.once="addCard" class="btn btn-primary mr-1 mt-1" :key="planStore.paymentBtnKey">
                                        {{ localizationStore.translate("add.card.modal.button.save") }}
                                    </button>
                                    <button @click="closeModal('#add-card-modal')" data-dismiss="modal" type="reset" class="btn btn-outline-secondary mt-1">
                                        {{ localizationStore.translate("add.card.modal.button.cancel") }}
                                    </button>
                                </div>
                            </div>
                        </template>
                    </payment-modal>
                </b-col>
                <b-col cols="12" xl="6" lg="6" md="6">
                    <user-two-steps-verification :data="user"/>
                </b-col>
            </b-row>
        </b-col>
        <b-col
            cols="12"
            lg="12"
        >
            <user-activity-timeline v-if="userStore.user.isDIY"/>
        </b-col>
    </b-row>
    <ssn-modal></ssn-modal>
</template>
<script>
import {
  BRow, BCol, BLink,
} from 'bootstrap-vue-3'
import UserInfoCard from './layout/UserInfoCard.vue'
import UserPlanView from './layout/UserPlanView.vue'
import UserActivityTimeline from './layout/UserActivityTimeline.vue'
import ResetAndDeactivate from './layout/ResetAndDeactivate.vue'
import UserTwoStepsVerification from './layout/UserTwoStepsVerification.vue'
import { useUserStore } from '../../stores/UserStore.js'
import axios from  'axios'
import PaymentModal from '../modals/PaymentComponent'
import { closeModal, hideModal, openModal } from '../../utilities/_helpers'
import { useBillingStore } from '../../stores/BillingStore.js'
import { useLocalizationStore } from '../../stores/LocalizationStore.js'
import { usePlanStore } from '../../stores/PlanStore.js'
import { useSettingStore } from '../../stores/SettingStore.js'

export default {
    name:'IndexComponent',
    components:{
        BRow,
        BCol,
        BLink,
        UserInfoCard,
        UserPlanView,
        UserActivityTimeline,
        ResetAndDeactivate,
        UserTwoStepsVerification,
        PaymentModal,
    },
    setup(props) {
        return{
            billingStore: useBillingStore(),
            closeModal: closeModal,
            localizationStore: useLocalizationStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            userStore: useUserStore(),
        }
    },
    data(){
        return{
            user:{}
        }
    },
    watch: {
        'userStore.profile'(value) {
            this.user = value.user
        },
    },
    methods: {
    },
    mounted() {
        let $this = this;
        if (document.readyState === "complete") {
            setTimeout(() => {
                this.$nextTick(() => {
                    if(!_.isEmpty(this.userStore.profile)){
                        $this.user = this.userStore.profile.user;
                    }else{
                        $this.userStore.fetchUserProfile();
                    }
                });
            }, 2000);
        } else {
            window.addEventListener("load", () => {
                setTimeout(() => {
                    this.$nextTick(() => {
                        if(!_.isEmpty(this.userStore.profile)){
                            $this.user = this.userStore.profile.user;
                        }else{
                            $this.userStore.fetchUserProfile();
                        }
                    });
                }, 2000);
            });
        }
    },
}
</script>
